<div class="head-box">

  <div class="main-box">

    <div class="main-txt">{{ dialect.word }}</div>
    <div class="sub-txt"
         *ngIf="dialect.wordMore && !select">{{ dialect.wordMore }}</div>
  </div>

  <div class="label-box">
    <article class="label-item type-{{ GetRegion2Css(dialect.area1) }}"
             *ngIf="dialect.area1">{{ GetRegion2Name(dialect.area1) }}</article>
    <!-- issue #208: 사투리 단어 내용에서는 area2(도시명)를 숨긴다.
    <article class="label-item type-{{ GetRegion2Css(dialect.area1) }}sub"
             *ngIf="dialect.area2">{{ dialect.area2 }}</article>
    -->
  </div>
</div>

<div class="body-box"
     [innerHTML]="briefMeaning | resize | keepHtml">
</div>
